<template>
    <div id="appointment-daily" ref="appointmentDailyBlock">
        <div class="row topactionform smallmargin">
            <div class="col-xs-5">
                <div class="smalltitle">Appointment<span style="padding-left: 10px; font-size: 13px">{{filterDateAppointmentStr}}</span>
                </div>
                Your Daily Calendar
            </div>
            <div class="col-xs-5">

                <form class="onelineform" @submit.prevent="filterAppointment">

                    <date-picker v-model="filterDateAppointment"
                                 format="MM/DD/YYYY"
                                 @change="changeFilterDate"
                                 :clearable=false
                                 :append-to-body=true
                                 :custom-button="true"
                                 lang="en"></date-picker>

                </form>

            </div>
            <div class="col-xs-2">
                <button type="button" @click.prevent="modalNewPatient = true"
                        class="btn light btn-block"><i class="fa fa-user-plus"></i> New Patient
                </button>
            </div>
        </div>
        <!--//new layout-->
        <div class="clear"></div>
        <div class="apt-wrapper editprosection-clearpadding" v-if="blockTimes.length">

            <div class="apt-col timeblock">
                <div class="itemlisthead" @click.prevent="showFullData" title="click to show/hide full table">
                    <span class="button-show-full">
                    <span><i class="fas fa-grip-horizontal"></i></span>
                        Time
                    </span>
                </div>
                <ul>
                    <li v-for="(titleTime, indexTime) in titleTimes"
                        v-show="checkShowFullTableTitleTime(titleTime.block)"
                    >
                        {{convertToTextTime(titleTime.block)}}
                    </li>

                </ul>
            </div>
            <div class="apt-block-fixed">
                <span class="apt-cal-btn inactive" id="apt-cal-left"><i class="fa fa-chevron-left"></i></span>
                <span class="apt-cal-btn inactive" id="apt-cal-right"><i class="fa fa-chevron-right"></i></span>
                <div class="apt-cal-wrap ">
                    <div class="apt-cal">
                        <div class="apt-col" v-for="(blockTime, indexTime) in blockTimes">
                            <div class="itemlisthead item-category-header" :ref="'block-header' + indexTime">
                                <span>{{blockTime.calendar.name}}</span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="apt-cal-wrap">
                <div class="apt-cal">
                    <div class="apt-col" v-for="(blockTime, indexTime) in blockTimes">
                        <!--<div class="itemlisthead item-category-header" :ref="'block-header' + indexTime">-->
                        <!--<span>{{blockTime.calendar.name}}</span>-->
                        <!--</div>-->
                        <ul style="margin-top: 42px">
                            <!--      //both boxTime and title time-->
                            <li :class="'block-time-each' + boxTime.time.block + checkShowFullTableTitleTime(boxTime.time.block)"
                                v-for="(boxTime,indexBoxTime) in blockTime.boxTime"
                                v-if="checkShowBoxTime(boxTime)"
                                v-show="checkShowFullTable(boxTime, blockTime) || checkShowFullTableTitleTime(boxTime.time.block)">
                                <span v-if="boxTime.itemAppointments" v-show="checkShowFullTable(boxTime, blockTime)"
                                      v-for="(item, indexDetailItem) in boxTime.itemAppointments">
                                          <div class="apt-item " :class="getClassCalendarColor(item)" v-if="item._id"
                                               :title="showTitleAppointment(item)"
                                               @click.prevent="editAppointment(blockTime.active, item,indexTime,indexBoxTime,indexDetailItem)">
                                              <span v-if="item.abbreviation">{{item.abbreviation}}</span>
                                              <span v-if="item.patient" class="appointment-name"
                                                    :class="getClassTextColor(item)">{{item.patient.fullName}}</span>
                                          </div>
                                        <div v-if="!item._id" class="apt-item "
                                             :class="{'empty' : !boxTime.disabled}"
                                             @click.prevent="addNewAppointment(boxTime.disabled,indexTime,indexBoxTime,indexDetailItem,blockTime.calendar,boxTime.time.block)"></div>
                                </span>
                            </li>
                        </ul>
                    </div>

                </div>

            </div>
            <div class="clear"></div>
        </div>


    </div>
</template>

<script>
import FilterLocation from '../../global/FilterLocation.vue'
import axios from '../../../src/client'
import Common from '../../components/mixins/Common.vue'
import DatePicker from '../../global/datepicker/DatePickerCustom.vue'

import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'AppointmentDaily',
  components: {
    DatePicker, FilterLocation
  },
  mixins: [Common],
  data () {
    return {
      options: {
        format: 'MM/DD/YYYY',
        useCurrent: true,
        lang: 'en'
      },
      filterDateAppointment: moment().format('MM/DD/YYYY'),
      filterDateAppointmentStr: '',
      dateAppointment: moment().format('MM/DD/YYYY'),
      filterLocation: '',
      filterStaff: '',
      modalNewPatient: false,
      modalNewAppointment: false,
      modalEditAppointment: false,
      listCalendarColumns: [],
      blockTimes: [],
      titleTimes: [],
      times: [],
      originalTimes: [],
      indexNewAppointment: {},
      indexEditAppointment: {},
      calendarNewAppointment: {},
      calendarEditAppointment: {},
      clinicLocations: [],
      processDataAppointment: true,
      openModalNewAppointment: false,
      newPatientAppointment: null,
      theFirstApplyScript: true,
      dataShow: {
        isShowFull: false,
        minTime: 1425,
        maxTime: 0
      }
    }
  },
  updated () {
    if (this.theFirstApplyScript) {
      this.initLayout()
      this.theFirstApplyScript = false
    }
  },
  computed: {
    ...mapGetters({
      isFullScreen: 'isFullScreen'
    })
  },
  watch: {
    'modalNewAppointment' (newVal, oldVal) {
      if (newVal == false) {
        this.newPatientAppointment = null
      }
    },
    'filterDateAppointment' (newVal, oldVal) {
      this.filterDateAppointmentStr = moment(newVal, 'MM/DD/YYYY').format('dddd, MMMM DD, YYYY')
    },
    'isFullScreen' (newVal, oldVal) {
      let vm = this
      setTimeout(function () {
        vm.initLayout()
      }, 1000)
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
    if (this.$store.getters.dateFilterSave != -1) {
      this.filterDateAppointment = this.$store.getters.dateFilterSave
    }
    this.originalTimes = this.generateTimeSheet()
    this.initData()
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll (event) {
      //      let container = this.$el.querySelector(".apt-block-fixed");
      //      console.log(window.scrollTop, container.scrollHeight,'22')
      this.updateTopForElementFixed()
    },
    updateTopForElementFixed () {
      let scrollTop = $(window).scrollTop()
      let heightToTop = 232
      if (scrollTop >= heightToTop) {
        $('.apt-block-fixed').css({ top: '0px' })
      } else {
        $('.apt-block-fixed').css({ top: (heightToTop - scrollTop) + 'px' })
      }
    },
    getClassCalendarColor (appoint) {
      if (['reschedule', 'cancel', 'noshow'].indexOf(appoint.appointmentStatus) > -1) {
        return 'grey_disabled'
      }
      return appoint.appointmentColor
    },
    getClassTextColor (appoint) {
      if (['reschedule', 'cancel', 'noshow'].indexOf(appoint.appointmentStatus) > -1) {
        return 'lime'
      }
      return appoint.textColor
    },
    checkShowFullTableTitleTime (block) {
      if (this.dataShow.isShowFull) {
        return true
      }
      if (block >= this.dataShow.minTime && block <= this.dataShow.maxTime) {
        return true
      }
      return false
    },
    checkShowFullTable (boxTime, blockTime) {
      if (this.dataShow.isShowFull) {
        return true
      }
      // block trong khoang setup thi show
      if (boxTime.time.block >= boxTime.minTimeSetup && boxTime.time.block <= boxTime.maxTimeSetup) {
        return true
      }
      return false
    },
    showFullData () {
      this.dataShow.isShowFull = !this.dataShow.isShowFull
    },
    generateTimeSheet () {
      let times = []// {block: '11:00 PM', status: 0},
      for (let i = 0; i <= 1425; i = i + 60) {
        times.push({ block: i, status: 0 })
      }
      return times
    },
    convertToTextTime (time) {
      if (typeof time !== 'number') {
        return ''
      }
      let additionTime = ' AM'
      if (time > 705) { // 11:45
        additionTime = ' PM'
      }
      let hour = 0
      let minute = 0
      hour = Math.floor(time / 60)
      minute = time % 60
      if (hour > 12) {
        hour = hour - 12
      }
      if (hour === 0) {
        hour = 12
      }
      return this.zeroPadded(hour) + ':' + this.zeroPadded(minute) + additionTime
    },
    showTitleAppointment (appointment) {
      let string = ''
      if (appointment) {
        let patient = appointment.patient
        if (!patient) {
          patient = appointment.patientData
        }
        if (patient) {
          string += patient.fullName
          string += ', ' + this.formatTime(patient)
          string += ', ' + patient.mrn
        }

        if (appointment.appointmentTypeName) {
          string += ', ' + appointment.appointmentTypeName
        }
        string += ', ' + appointment.timeColumn
        if (appointment.dateCreate) {
          string += ', ' + moment(appointment.dateCreate).format('MM/DD/YYYY')
        }
        string += ', ' + ((appointment.doctor) ? appointment.doctor.fullName : '')
        string += ', ' + ((appointment.location) ? appointment.location.name : '')
        string += '. Booked by: ' + ((appointment.creator) ? appointment.creator.fullName : '')
        if (moment(appointment.createdAt).format('MM/DD/YYYY') !== '01/01/1970') {
          string += ', ' + moment(appointment.createdAt).format('MM/DD/YYYY')
        }
      }
      return string
    },
    updateFilterLocation (data) {
      if (data.location) {
        this.filterLocation = data.location.name
      }
      if (data.staff) {
        this.filterStaff = data.staff._id
      }
    },
    // check only box to show
    checkShowBoxTime (boxTime) {
      if (boxTime.time) {
        let time = boxTime.time.block
        let index = this.titleTimes.findIndex(x => x.block == time)
        if (index > -1) {
          return true
        }
      }

      return false
    },
    createNewPatient (data) {
      this.modalNewPatient = true
      this.openModalNewAppointment = true
    },
    updateAfterCreatePatient (patient) {
      if (this.openModalNewAppointment) {
        this.newPatientAppointment = patient
        this.modalNewAppointment = true
      }
    },
    filterAppointment () {
      this.dateAppointment = this.filterDateAppointment
      this.$store.commit('setDateFilterSave', this.dateAppointment)
      this.initData()
    },
    changeFilterDate (date) {
      this.filterDateAppointment = moment(this.filterDateAppointment).format('MM/DD/YYYY')
      this.filterAppointment()
    },
    updateAppointmentAfterEdit (appointment) {
      if (appointment.typeAction === 'delete') {
        this.blockTimes[this.indexEditAppointment.indexTime].boxTime[this.indexEditAppointment.indexItem].itemAppointments.splice(this.indexEditAppointment.indexDetailItem, 1)
      } else {
        this.blockTimes[this.indexEditAppointment.indexTime].boxTime[this.indexEditAppointment.indexItem].itemAppointments[this.indexEditAppointment.indexDetailItem].abbreviation = appointment.abbreviation
        this.blockTimes[this.indexEditAppointment.indexTime].boxTime[this.indexEditAppointment.indexItem].itemAppointments[this.indexEditAppointment.indexDetailItem].appointmentStatus = appointment.appointmentStatus
        this.blockTimes[this.indexEditAppointment.indexTime].boxTime[this.indexEditAppointment.indexItem].itemAppointments[this.indexEditAppointment.indexDetailItem].appointmentTypeName = appointment.appointmentTypeName
        this.blockTimes[this.indexEditAppointment.indexTime].boxTime[this.indexEditAppointment.indexItem].itemAppointments[this.indexEditAppointment.indexDetailItem].appointmentColor = appointment.appointmentColor
        this.blockTimes[this.indexEditAppointment.indexTime].boxTime[this.indexEditAppointment.indexItem].itemAppointments[this.indexEditAppointment.indexDetailItem].textColor = appointment.textColor
      }
    },
    editAppointment (blockActive, item, indexTime, indexItem, indexDetailItem) {
      if (blockActive) {
        this.indexEditAppointment.indexTime = indexTime
        this.indexEditAppointment.indexItem = indexItem
        this.indexEditAppointment.indexDetailItem = indexDetailItem
        this.calendarEditAppointment = item
        this.modalEditAppointment = true
      }
    },
    updateAppointmentAfterCreate (newAppointment) {
      let countBox = this.blockTimes[this.indexNewAppointment.indexTime].calendar.appointmentEachBlock
      this.blockTimes[this.indexNewAppointment.indexTime].boxTime[this.indexNewAppointment.indexItem].itemAppointments[this.indexNewAppointment.indexDetailItem] = newAppointment
      //              if number of item smaller than coutBox, add new empty item
      if (this.blockTimes[this.indexNewAppointment.indexTime].boxTime[this.indexNewAppointment.indexItem].itemAppointments.length < countBox) {
        let countEmpty = this.blockTimes[this.indexNewAppointment.indexTime].boxTime[this.indexNewAppointment.indexItem].itemAppointments.filter(x => {
          return (x === 1)
        })
        if (countEmpty.length === 0) {
          this.blockTimes[this.indexNewAppointment.indexTime].boxTime[this.indexNewAppointment.indexItem].itemAppointments.push(1)
        }
      }
    },
    addNewAppointment (disabled, indexTime, indexItem, indexDetailItem, calendar, timeText) {
      if (disabled) {
        return
      }
      // if (!this.storeSelectedLocation) {
      //   this.alertError('Please choose a location before making the appointment.')
      //   return
      // }
      let dayAppointment = (this.filterDateAppointment !== 'Invalid date') ? this.filterDateAppointment : moment().format('MM/DD/YYYY')
      calendar.timeColumn = this.convertToTextTime(timeText)
      calendar.dayAppointment = dayAppointment
      this.calendarNewAppointment = calendar
      this.indexNewAppointment.indexTime = indexTime
      this.indexNewAppointment.indexItem = indexItem
      this.indexNewAppointment.indexDetailItem = indexDetailItem
      this.modalNewAppointment = true
    },
    initData () {
      if (!this.filterDateAppointment || this.filterDateAppointment === 'Invalid date') {
        this.alertError('Please choose a date to search')
        this.processDataAppointment = true
        return
      }
      if (this.processDataAppointment) {
        this.processDataAppointment = false
        let params = {
          date: this.filterDateAppointment,
          locationIdWiki: (this.storeLocationObject) ? this.storeLocationObject.idWiki : null,
          doctorId: this.storeSelectedStaff
        }
        this.times = JSON.parse(JSON.stringify(this.originalTimes))
        axios.get(`/appointment/daily/init-data`, {
          params: params
        }).then(response => {
          this.processDataAppointment = true
          if (response.data.s === 200) {
            //            this.listCalendarColumns = response.data.data.calendarColumns
            let arrayHard = ['Membership', 'Event', 'Ticket', 'Addition Fee', 'Sponsorship', 'Emr', 'Patient bill']
            let calendarCategories = []
            for (let i = 0; i < arrayHard.length; i++) {
              calendarCategories.push(
                {
                  appointmentEachBlock: 3,
                  endTime: '05:00 PM',
                  name: arrayHard[i],
                  order: i + 1,
                  startTime: '08:00 AM',
                  _id: '6220f06981700a2e124c3989' + i
                }
              )
            }
            this.listCalendarColumns = calendarCategories
            let appointments = response.data.data.appointments
            let calendarColumns = this.listCalendarColumns
            let startTime = ''
            let endTime = ''
            let appointmentEachBlock = 0
            let dataBlockTime = []
            // current calendarColumns
            //
            for (let j = 0; j < calendarColumns.length; j++) {
              let data = {}

              data.calendar = calendarColumns[j]
              data.active = 1 // check appointment exist in calendar
              data.boxTime = []
              startTime = calendarColumns[j].startTime
              endTime = calendarColumns[j].endTime
              let mainStartTime = startTime
              let mainEndTime = endTime
              // setup min max time to show full
              if (this.exchangeTextTimeToInt(startTime) < this.dataShow.minTime) {
                this.dataShow.minTime = this.exchangeTextTimeToInt(startTime)
              }
              if (this.exchangeTextTimeToInt(endTime) > this.dataShow.maxTime) {
                this.dataShow.maxTime = this.exchangeTextTimeToInt(endTime)
              }
              // recalculate min max range time
              let timeAppointmentMinMax = this.findMinMaxTime(appointments[calendarColumns[j].name])
              if (timeAppointmentMinMax) {
                if (this.exchangeTextTimeToInt(mainStartTime) > this.exchangeTextTimeToInt(timeAppointmentMinMax.min)) {
                  mainStartTime = timeAppointmentMinMax.min
                }
                if (this.exchangeTextTimeToInt(mainEndTime) < this.exchangeTextTimeToInt(timeAppointmentMinMax.max)) {
                  mainEndTime = timeAppointmentMinMax.max
                }
              }
              for (let i = 0; i < this.times.length; i++) {
                appointmentEachBlock = (calendarColumns[j].appointmentEachBlock) ? calendarColumns[j].appointmentEachBlock : 1000
                let block = {}
                block.time = this.times[i] // block time
                block.minTimeSetup = this.exchangeTextTimeToInt(startTime) // check ẩn hiện
                block.maxTimeSetup = this.exchangeTextTimeToInt(endTime) // check ẩn hiện
                block.disabled = true
                // block in range time ,show block
                if (this.exchangeTextTimeToInt(mainStartTime) <= this.times[i].block && this.times[i].block <= this.exchangeTextTimeToInt(mainEndTime)) {
                  // block in range time ,able to create new appointment
                  if (this.exchangeTextTimeToInt(startTime) <= this.times[i].block && this.times[i].block <= this.exchangeTextTimeToInt(endTime)) {
                    block.disabled = false
                  }
                  this.times[i].status = 1
                  let itemAppointments = []
                  if (appointments[calendarColumns[j].name]) {
                    itemAppointments = appointments[calendarColumns[j].name].filter(x => {
                      // if time is range block time + 15,its belong to block
                      if (this.exchangeTextTimeToInt(x.timeColumn) >= this.times[i].block &&
                          this.exchangeTextTimeToInt(x.timeColumn) < (this.times[i].block + 15)) {
                        return true
                      }
                      return false
                    })
                  }
                  if (itemAppointments.length >= 5 && appointmentEachBlock > itemAppointments.length) {
                    itemAppointments.push(1)
                  }
                  if (itemAppointments.length < appointmentEachBlock && itemAppointments.length < 5) {
                    let sub = 5 - itemAppointments.length
                    for (let t = 1; t <= sub; t++) {
                      itemAppointments.push(1)
                    }
                  }
                  block.itemAppointments = itemAppointments
                  data.boxTime.push(block)
                } else if (this.exchangeTextTimeToInt(startTime) > this.times[i].block) { // print block from startTime to end time
                  data.boxTime.push(block)
                } else {
                  break
                }
              }
              dataBlockTime.push(data)
              // remove appointment exist in calendar
              delete appointments[calendarColumns[j].name]
            }
            // add appointment not in calendar column
            //              for (let keyAppointment in appointments) {
            //                if (appointments.hasOwnProperty(keyAppointment)) {
            //                  let startTime = ''
            //                  let endTime = ''
            //                  let listAppointment = appointments[keyAppointment]
            //                  if (listAppointment && listAppointment.length) {
            //                    let timeAppointment = this.findMinMaxTime(listAppointment)
            //                    startTime = timeAppointment.min
            //                    endTime = timeAppointment.max
            //                    let data = {}
            //                    data.calendar = { name: keyAppointment }
            //                    data.active = 0
            //                    data.boxTime = []
            //                    for (let i = 0; i < this.times.length; i++) {
            //                      let block = {}
            //                      block.time = this.times[i]
            //                      if (this.exchangeTextTimeToInt(startTime) <= this.times[i].block && this.times[i].block <= this.exchangeTextTimeToInt(endTime)) {
            //                        this.times[i].status = 1
            //                        block.itemAppointments = listAppointment.filter(x => x.timeColumn === this.times[i].block)
            //                        data.boxTime.push(block)
            //                      } else if (this.exchangeTextTimeToInt(endTime) < this.times[i].block) {
            //                        break
            //                      }
            //                    }
            //                    dataBlockTime.unshift(data)
            //                  }
            //                }
            //              }
            this.blockTimes = dataBlockTime
            this.titleTimes = this.times.filter(x => {
              return (x.status === 1)
            })
            // init layout script
            this.theFirstApplyScript = true
          } else {
            this.alertError('Error! Try again later!')
          }
        }).catch(e => {
          this.processDataAppointment = true
          this.alertError(e.message)
        })
      }
    },
    findMinMaxTime (listAppointment) {
      if (!listAppointment) {
        return null
      }
      let min = ''
      let max = ''
      listAppointment.map(appointment => {
        if (!min || this.exchangeTextTimeToInt(appointment.timeColumn) < this.exchangeTextTimeToInt(min)) {
          min = appointment.timeColumn
        }
        if (!max || this.exchangeTextTimeToInt(appointment.timeColumn) > this.exchangeTextTimeToInt(max)) {
          max = appointment.timeColumn
        }
      })
      return {
        min: min,
        max: max
      }
    },
    // 6:00 PM
    exchangeTextTimeToInt (time) {
      if (!time) {
        return 0
      }
      time = time.split(' ')
      let ext = time[1]

      let hour = time[0].split(':')[0]
      let minute = time[0].split(':')[1]
      hour = parseInt(hour)
      minute = parseInt(minute)
      if (ext === 'PM') {
        if (hour < 12) {
          hour = Number(hour) + 12
        }
      }
      if (ext === 'AM' && hour === 12) {
        hour = 0
      }
      return (Number)(hour * 60 + minute)
    },
    initLayout () {
      let cstep = 0
      let boxN = $('.apt-block-fixed .apt-cal .apt-col:not(.timeblock)').length
      let colN = 7 // columns show per click
      let colNf = 10 // columns show per click on fullwidth more
      if ($('body').hasClass('fullscreen')) {
        colN = colNf
      }
      let mainWidth = this.$refs['appointmentDailyBlock'].clientWidth + 62
      let colW = (mainWidth - 60) / colN // default column width

      let colstep = Math.ceil(boxN / colN)
      $('.apt-col:not(.timeblock)').width(colW)

      $('.apt-col > .item-category-header').width(colW - 20)
      let fullWidthFixed = colN * colW + 60 - 2
      $('.apt-block-fixed').width(fullWidthFixed)
      $('#apt-cal-right').css({ 'left': (fullWidthFixed - 70) + 'px' })

      $('.apt-cal').width(boxN * colW)

      if (boxN > colN) {
        $('#apt-cal-right').removeClass('inactive')
      }
      $('.apt-cal-wrap').stop().animate({ scrollLeft: 0 })
      $('.apt-cal-btn').on('click', function (e) {
        e.preventDefault()
        if (cstep < colstep) {
          cstep = this.id == 'apt-cal-right' ? cstep + 1 : cstep - 1
          if (cstep <= 0) {
            cstep = 0
            $('#apt-cal-left').addClass('inactive')
          } else {
            $('#apt-cal-left').removeClass('inactive')
          }
          if (cstep == colstep - 1) {
            $('#apt-cal-right').addClass('inactive')
          } else {
            $('#apt-cal-right').removeClass('inactive')
          }

          let boxL = $('.apt-cal .apt-col:not(.timeblock)').eq(cstep).position().left
          // alert(cstep + 'po' + boxL + 'id' +  $('.apt-cal .apt-col:not(.timeblock)').eq( cstep ).find('.itemlisthead').text())
          $('.apt-cal-wrap').stop().animate({ scrollLeft: boxL * colN })
        }
      })
    }
  }
}
</script>
<style scoped="">
    .box-filter-location {
        width: 62%;
    }

    .apt-item.black {
        background-color: #000 !important;
    }

    .apt-item.red {
        background-color: #F7412C !important;
    }

    .apt-item.pink {
        background-color: #EC1562 !important;
    }

    .apt-item.purple {
        background-color: #9D1DB2 !important;
    }

    .apt-item.deep_purple {
        background-color: #6834BC !important;
    }

    .apt-item.indigo {
        background-color: #3F4DB8 !important;
    }

    .apt-item.blue {
        background-color: #1294F6 !important;
    }

    .apt-item.light_blue {
        background-color: #00A7F6 !important;
    }

    .apt-item.cyan {
        background-color: #00BCD7 !important;
    }

    .apt-item.teal {
        background-color: #009788 !important;
    }

    .apt-item.green {
        background-color: #48B14C !important;
    }

    .apt-item.light_green {
        background-color: #89C541 !important;
    }

    .apt-item.lime {
        background-color: #CDDE20 !important;
    }

    .apt-item.yellow {
        background-color: #FEED19 !important;
    }

    .apt-item.amber {
        background-color: #FEC200 !important;
    }

    .apt-item.orange {
        background-color: #FE9900 !important;
    }

    .apt-item.deep_orange {
        background-color: #FF5608 !important;
    }

    .apt-item.brown {
        background-color: #7B5548 !important;
    }

    .apt-item.grey {
        background-color: #9E9E9E !important;
    }

    .apt-item.grey_disabled {
        background-color: #9E9E9E !important;
        opacity: 0.5;
    }

    .apt-item.blue_grey {
        background-color: #607D8D !important;
    }

    /*//text-clor*/
    .appointment-name.black {
        color: #000 !important;
    }

    .appointment-name.red {
        color: #F7412C !important;
    }

    .appointment-name.pink {
        color: #EC1562 !important;
    }

    .appointment-name.purple {
        color: #9D1DB2 !important;
    }

    .appointment-name.deep_purple {
        color: #6834BC !important;
    }

    .appointment-name.indigo {
        color: #3F4DB8 !important;
    }

    .appointment-name.blue {
        color: #1294F6 !important;
    }

    .appointment-name.light_blue {
        color: #00A7F6 !important;
    }

    .appointment-name.cyan {
        color: #00BCD7 !important;
    }

    .appointment-name.teal {
        color: #009788 !important;
    }

    .appointment-name.green {
        color: #48B14C !important;
    }

    .appointment-name.light_green {
        color: #89C541 !important;
    }

    .appointment-name.lime {
        color: #CDDE20 !important;
    }

    .appointment-name.yellow {
        color: #FEED19 !important;
    }

    .appointment-name.amber {
        color: #FEC200 !important;
    }

    .appointment-name.orange {
        color: #FE9900 !important;
    }

    .appointment-name.deep_orange {
        color: #FF5608 !important;
    }

    .appointment-name.brown {
        color: #7B5548 !important;
    }

    .appointment-name.grey {
        color: #9E9E9E !important;
    }

    .appointment-name.blue_grey {
        color: #607D8D !important;
    }

    .item-category-header {
        /*position: fixed;*/
        /*z-index: 1000000000000000000;*/
        /*background: white;*/
    }

    .apt-block-fixed {
        position: fixed !important;
        z-index: 99;
        margin-left: 60px;
        background: white;
        top: 232px;
    }

    #apt-cal-left {
        left: 0px;
    }

    .apt-cal-btn {
        z-index: 99;
    }
</style>
<style>
    .button-show-full {
        width: 100px;
    }

    .button-show-full i {
        color: #bec500;
    }

    li {
        list-style: none !important;
    }

    #appointment-daily .mx-datepicker {
        width: 31%;
        float: right;
    }

    #appointment-daily .mx-input {
        margin: 0px;
        height: 40px;
    }

    #appointment-daily .onelineform {
        border-left: none;
    }

    .editpromenu .dropdown-content {
        z-index: 100000;
    }
</style>
